import { Button } from "../ui";
import { ctaTranslate } from "../lib/ctaTranslate";
import { navigateExternal, gaCtaClickPayload } from "../lib/postmessage";

interface CtaButtonData {
  /** 화면에 노출되는 버튼 라벨 (현지화는 Agent/MCP 측에서 미리 결정). */
  label: string;
  /** i18n 코드 (예: "nav_cta.take_me_to_my_basket"). 서버 create_cta 가 채운다. */
  ctaKey: string;
  /** ctaKey 템플릿 파라미터. */
  ctaParams?: Record<string, string | number>;
  style?: "primary" | "secondary";
  /** 클릭 시 NCMS 페이지 이동 URL (예: "/cart"). 있으면 navigateExternal 호출. */
  navigateUrl?: string;
  /** NCMS 장바구니 프로모션 코드 입력용 (서버 create_cta 가 채움). */
  couponCode?: string;
  /** [legacy] 직접 발화문이 주어진 경우 (사용 금지). */
  message?: string;
}

interface Props {
  data: CtaButtonData;
  sessionToken: string;
}

export default function CtaButtonCard({ data, sessionToken }: Props) {
  const isPrimary = data.style === "primary";

  const handleClick = () => {
    if (data.navigateUrl) {
      const navExtra: Record<string, string> = { target: "_top" };
      const couponCode = data.couponCode?.trim();
      if (couponCode) {
        navExtra.code = couponCode;
      }
      // B-5-1: 링크아웃 CTA(Go to Basket 등) — asklg_shop_next_btn_click 를 navigate 에 임베드(이동 전 GA).
      navigateExternal(
        data.navigateUrl,
        navExtra,
        { sessionId: sessionToken },
        gaCtaClickPayload(data.label),
      );
    }
    if (!data.ctaKey) {
      return;
    }
    void ctaTranslate({
      code: data.ctaKey,
      params: data.ctaParams,
      sessionToken,
      fallback: data.message || data.label,
    });
  };

  // AISASSIT-162: 구매하기 화면 CTA 버튼 — Figma(2571-13378) small(sm) 사이즈,
  // .ai-gp1-btn-wrap(콘텐츠 폭·좌측정렬). 기존 .ac-cta 풀폭/xs 에서 정합.
  return (
    <div className="ai-gp1--section">
      <div className="ai-gp1-btn-wrap">
        <Button
          variant={isPrimary ? "primary" : "secondary"}
          size="sm"
          onClick={handleClick}
        >
          {data.label}
        </Button>
      </div>
    </div>
  );
}
